// FilterList
import React from 'react';
import PropTypes from 'prop-types';

const FilterTabItem = ({ filterClick, option }) => (
  <li role="presentation" key={option.name.toLowerCase().replace(/[\s]+/g, '-')} className={(option.isChecked === true ? 'tab-list-item active' : 'tab-list-item')}>
    <button role="tab" aria-controls={(option.name === 'Images' ? 'media-type-tab-panel-images-panel' : 'media-type-tab-panel-videos-panel')} aria-expanded={(option.isChecked === true ? 'true' : 'false')} className="tab tab-link" id={option.name.toLowerCase().replace(/[\s]+/g, '-')} onClick={() => filterClick(option)}>
      {option.name}
    </button>
  </li>
);

FilterTabItem.propTypes = {
  filterClick: PropTypes.func.isRequired,
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isChecked: PropTypes.bool.isRequired,
  }),
};

const FilterSelectBoxItem = ({ option }) => (
  <option key={option.name.toLowerCase().replace(/[\s]+/g, '-')} value={option.name}>
    {option.name}
  </option>
);

FilterSelectBoxItem.propTypes = {
  option: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
};

export {
  FilterTabItem,
  FilterSelectBoxItem,
};
